import React, { useState } from 'react';
import './../entrydoor.css';

const ScreenFrameMatch = ({ value, onChangelabel = 'ScreenFrameMatch:', disabled = false }) => {
    const [selectedScreenFrameMatch, setSelectedScreenFrameMatch] = useState(value || "Yes");

    const handleScreenFrameMatchChange = (e) => {
        setSelectedScreenFrameMatch(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label  style={{ display: "none" }} disabled={disabled} htmlFor="ScreenFrameMatch">{label}</label>
            <select style={{ display: "none" }}
                disabled={disabled}
                id="ScreenFrameMatch"
                value={selectedScreenFrameMatch}
                onChange={handleScreenFrameMatchChange}
            >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
            </select>
        </div>
    );
};

export default ScreenFrameMatch;
